// extracted by mini-css-extract-plugin
export default {"main":"Co2_main__7qwOp"};